import { useState } from "react";
import { getResponsiveImageProps } from "../../utils/imageVariants";
import { getScrapDecoration } from "../../utils/getScrapDecoration";

import Lightbox from "../../components/lightbox/Lightbox";

export default function ProyectoB({
  title,
  author,
  description,
  graphics = [],
  decorations = [], 
  decorationsData = [],
  reverse = false,
}) {
  const [lightboxData, setLightboxData] = useState(null);
  const [mobileOverlay, setMobileOverlay] = useState(false);
  const [preloaded, setPreloaded] = useState(false);

  const AUTHOR_LABELS = {
    autor1: "Ana Montesino",
    autor2: "Agustina Lubris"
  };

  const pin = getScrapDecoration(decorationsData, decorations, "pin");
  const tape = getScrapDecoration(decorationsData, decorations, "tape");

  const mainImage = graphics[0];

  const preloadImages = () => {
    if (preloaded) return;
    setPreloaded(true);

    graphics.forEach(img => {
      if (!img?.sizes) return;

      const sizes = Object.keys(img.sizes)
        .map(Number)
        .sort((a, b) => b - a);

      const largestKey = sizes[0];
      const largest = img.sizes[largestKey];

      if (largest?.path) {
        const image = new Image();
        image.src = largest.path;
      }
    });
  };

  return (
    <>
      <article className={`proyectoB ${reverse ? "proyectoB-reverse" : ""} `}>
        <div className={`proyectoB-visual scrap-base ${pin?.className || ""} `}  style={pin?.style}>
          <div className="proyectoB-image">
            <div className="proyectoB-imageInner">
              {mainImage && mainImage.sizes && (() => {
                const baseSize =
                  mainImage.sizes?.[600] || Object.values(mainImage.sizes)[0];

                return (
                  <div className={`scrap-base ${tape?.className || ""}`}  style={tape?.style}>
                    <div className={` proyectoB-imgWrap`}>
                      <img
                        {...getResponsiveImageProps({
                          image: mainImage,
                          sizes: "(max-width: 768px) 95vw, 1200px"
                        })}
                        width={baseSize.realWidth}
                        height={baseSize.realHeight}
                        style={{
                          aspectRatio: `${baseSize.realWidth} / ${baseSize.realHeight}`
                        }}
                        loading="lazy"
                        decoding="async"
                        alt={title}
                        onClick={() =>
                          setLightboxData({
                            images: graphics,
                            index: 0
                          })
                        }
                      />
                      
                      <div
                        className={`proyectoB-overlay ${
                          mobileOverlay ? "active-mobile" : ""
                        }`}
                        role="button"
                        tabIndex={0}
                        onMouseEnter={preloadImages}
                        onFocus={preloadImages}
                        onClick={() => {
                          if (window.innerWidth < 768) {
                            setMobileOverlay(!mobileOverlay);
                          } else {
                            setLightboxData({
                              images: graphics,
                              index: 0
                            });
                          }
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            setLightboxData({
                              images: graphics,
                              index: 0
                            });
                          }
                        }}
                      >
                        <h4>{title}</h4>
                        <span>Ver galería</span>
                      </div>

                    </div>
                  </div>
                );
              })()}

            </div>
            
          </div>
          <span className="proyectoB-divider"></span>
          <div className="proyectoB-content">
            <h3 className="proyectoB-title">{title}</h3>
            <span>{AUTHOR_LABELS[author]}</span>
            <p className="proyectoB-text">{description}</p>
          </div>
        </div>
      </article>

      {lightboxData && (
        <Lightbox
          images={lightboxData.images}
          startIndex={lightboxData.index}
          onClose={() => setLightboxData(null)}
        />
      )}
    </>
  );
}
